import { Component, OnInit, Inject } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { ArquivoResumoPedidoService } from 'src/app/services/arquivo-resumo-pedido.service';

@Component({
  selector: 'app-variaveis-arquivo-resumo-pedido-modal',
  templateUrl: './variaveis-arquivo-resumo-pedido-modal.component.html',
  styleUrls: ['./variaveis-arquivo-resumo-pedido-modal.component.scss']
})
export class VariaveisArquivoResumoPedidoModalComponent implements OnInit {

  monitorSelecionadoDescricao = undefined;
  monitorSelecionado = undefined;
  variaveis = [];

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private dialogRef: MatDialogRef<VariaveisArquivoResumoPedidoModalComponent>,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private arquivoResumoPedidoService: ArquivoResumoPedidoService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.monitorSelecionado = data.monitorSelecionado;
    this.monitorSelecionadoDescricao = data.monitorSelecionadoDescricao;
  }

  ngOnInit(): void {
    this.buscarVariaveis();
  }

  buscarVariaveis() {

    const ocultarValores = this.monitorSelecionado === 1 || this.monitorSelecionado === 4 || this.monitorSelecionado === 5 || this.monitorSelecionado === 6;

    this.carregandoService.mostra('buscarVariaveis');

    this.arquivoResumoPedidoService.consultarVariaveis(ocultarValores).subscribe(
      (variaveis) => {
        this.variaveis = variaveis;
        this.carregandoService.esconde('buscarVariaveis');
      },
      (erro) => {
        this.carregandoService.esconde('buscarVariaveis');
        this.notificacaoService.erro(erro);
      }
    );
  }

  fechar() {
    this.dialogRef.close();
  }

}
